// 🔒
const tinaProfile = new URL("../assets/tina-profile.webp", import.meta.url).href;
const matejProfile = new URL("../assets/matej-profile.webp", import.meta.url).href;
const jurijProfile = new URL("../assets/jurij-profile.webp", import.meta.url).href;
const igorProfile = new URL("../assets/igor-profile.webp", import.meta.url).href;
const katrinProfile = new URL("../assets/katrin-profile.webp", import.meta.url).href;
const lukaProfile = new URL("../assets/luka-profile.webp", import.meta.url).href;

export const trainers = [
  {
    id: 1,
    slug: "tina-pecaver",
    name: "Tina Pečaver",
    role: "Licensed Personal Trainer",
    description: "Tina specializes in strength, conditioning, and HYROX training designed to improve fitness and overall physical performance. Her workouts are structured, effective, and built to help you grow stronger, fitter, and more confident with every session.",
    specialties: ["Hyrox", "Women's fitness", "Fat loss", "Strenght training"],
    experience: "6+",
    clients: "100+",
    programs: "3",
    image: tinaProfile,
    appPreviewImage: tinaProfile,
    previewVideo: "1186511903?h=2de4a67159"
  },
  {
    id: 2,
    slug: "matej-krestic",
    name: "Matej Kreštić",
    role: "Licensed Personal Trainer",
    description: "With over 18 years of experience, Matej brings a tailored system for building an aesthetic physique suited to all levels. His goal is to give you the knowledge and guidance to train with confidence and turn your fitness journey into a lasting success story.",
    specialties: ["Bodybuilding", "Fat loss", "Muscle gain", "Conditioning"],
    experience: "18+",
    clients: "300+",
    programs: "4",
    image: matejProfile,
    appPreviewImage: matejProfile,
    previewVideo: "1188832223?h=cd89475eab"
  },
  {
    id: 3,
    slug: "jurij-spanja",
    name: "Jurij Španja",
    role: "Licensed Personal Trainer",
    description: "Jurij has guided over 150 people through real transformations — both physical and mental. He believes in smart, holistic coaching tailored to each person's lifestyle, always putting long-term health and sustainability at the center of every program he creates.",
    specialties: ["Functional fitness", "Muscle gain", "Conditioning", "Mobility"],
    experience: "6+",
    clients: "100+",
    programs: "4",
    image: jurijProfile,
    appPreviewImage: jurijProfile,
    previewVideo: "1185567921?h=3932ba4eb0"
  },
  {
    id: 4,
    slug: "igor-martic",
    name: "Igor Martić",
    role: "Licensed Personal Trainer",
    description: "With over five years in the fitness industry, Igor is passionate about showing people that training can be genuinely enjoyable. His mission is to make the gym an inspiring, rewarding space — not just a place to count reps, but a sustainable part of a healthy lifestyle.",
    specialties: ["Fat loss", "Muscle gain", "Strenght training"],
    experience: "5+",
    clients: "50+",
    programs: "3",
    image: igorProfile,
    appPreviewImage: igorProfile,
    previewVideo: "1185504491?h=284861f02b"
  },
  {
    id: 5,
    slug: "katrin-don",
    name: "Katrin Don",
    role: "Mag. Kinesiologist",
    description: "Katrin works with both recreational and athletic populations, focusing on movement quality, injury prevention, and sustainable performance. Her coaching is grounded in kinesiology and designed to build real-life strength, long-term consistency, and a body that moves and feels its best.",
    specialties: ["Pilates", "Rehab", "Fat loss", "Muscle gain"],
    experience: "7+",
    clients: "100+",
    programs: "2",
    image: katrinProfile,
    appPreviewImage: katrinProfile,
    previewVideo: "1187732170?h=6cb4527067"
  },
  {
    id: 6,
    slug: "luka-golob",
    name: "Luka Golob",
    role: "Licensed Personal Trainer",
    description: "Luka combines high-intensity CrossFit and HYROX training with Olympic weightlifting, strength and endurance work, and professional injury rehabilitation. His programs are built for those who want to push their limits and develop well-rounded, elite-level fitness that carries over into real life.",
    specialties: ["Hyrox", "Weightlifting", "Crossfit", "Gimnastics", "Muscle gain"],
    experience: "10+",
    clients: "150+",
    programs: "2",
    image: lukaProfile,
    appPreviewImage: lukaProfile,
    previewVideo: "1186644571?h=3d0575da19"
  }
];
// 🔒
